import BaseComponent from '../../../js/base-component'
import { Splide } from '@splidejs/splide/build/complete/complete';

class ServicesTeaser extends BaseComponent {
  constructor(options) {
    super(options);
  }
  onInit() {
    if (this.element.classList.contains('has--slider') ) {
      let sliderContainer = this.element.querySelector('.u-services-teaser__slider');

      if (sliderContainer !== null) {
        this.splide = new Splide(sliderContainer, {
            breakpoints: {
                767: {
                    arrows: false,
                    pagination: true,
                    perPage: 1,
                    perMove: 1,
                },
            },
            destroy: true,
          }
        );

        this.splide.mount();
      }

    }
  }
}

export default {
  name: 'ServicesTeaser',
  definition: ServicesTeaser
};